"use client"

import React from "react";

const InfoBox = ({ icon, heading, description }) => {
  return (
    <div className="relative rounded-[20px] shadow-lg p-6 lg:h-[360px] lg:w-[578px] text-start bg-[#FAF9FE]">
      <div className="absolute -top-14 left-6 bg-white rounded-full w-[100px] h-[100px] flex items-center justify-center shadow-md">
        <img src={icon} alt="icon" className="w-[86px] h-[76px]" />
      </div>
      <h3 className="bg-custom-radial bg-clip-text text-transparent font-aileron text-[28px] lg:text-[36px] font-bold mt-10 w-[85%] ">{heading}</h3>
      <p className="font-lato text-[16px] lg:text-[18px] mt-2 w-[100%]">{description}</p>
    </div>
  );
};

export default InfoBox;
